export function LoadingState(props: { label?: string }) {
  return <div className="muted">{props.label ?? "Loading…"}</div>;
}

export function EmptyState(props: { title: string; detail?: string }) {
  return (
    <div className="card">
      <div style={{ fontWeight: 700, marginBottom: 6 }}>{props.title}</div>
      {props.detail ? <div className="muted">{props.detail}</div> : null}
    </div>
  );
}

/**
 * Something opened by link that the person may not use — what it reads is
 * outside their subject areas, or restricted for them. No name, no id, no
 * reason: the same answer whether it exists or not.
 */
export function NotAvailableState(props: { thing: string }) {
  return (
    <div className="card">
      <div style={{ fontWeight: 700, marginBottom: 6 }}>Not available</div>
      <div className="muted">This {props.thing} is not available to you — ask an administrator.</div>
    </div>
  );
}

export function ErrorState(props: { title?: string; detail: string }) {
  return (
    <div className="card" style={{ borderColor: "var(--danger-border)", background: "var(--danger-bg)" }}>
      <div style={{ fontWeight: 700, marginBottom: 6, color: "var(--danger-text)" }}>{props.title ?? "Error"}</div>
      <div className="muted">{props.detail}</div>
    </div>
  );
}

